(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  const setHeaderColour = (item) => {
    const header = document.querySelector('#header');
    if (!header) return;

    if (!item || item.dataset.headerColour !== 'true') {
      delete header.dataset.funnelColor;
      return;
    }

    header.dataset.funnelColor = item.dataset.hoverText === 'white' ? 'white' : 'black';
  };

  const initHeroFunnels = (root = document) => {
    root.querySelectorAll('.hero-funnel').forEach((hero) => {
      if (hero.dataset.funnelInitialized === 'true') return;
      hero.dataset.funnelInitialized = 'true';

      const items = Array.from(hero.querySelectorAll('.funnel-item'));
      if (!items.length) return;

      const updateHeaderColour = () => {
        const item = mobileQuery.matches
          ? items[items.length - 1]
          : hero.querySelector('.funnel-item.is-active');
        setHeaderColour(item);
      };

      const activate = (item) => {
        items.forEach((candidate) => {
          candidate.classList.toggle('is-active', candidate === item);
        });
        updateHeaderColour();
      };

      // Start with the first image visible. On mobile, the last item still
      // controls the header colour, as requested.
      activate(items[0]);
      items.forEach((item) => {
        item.addEventListener('pointerenter', () => activate(item));
        item.addEventListener('focusin', () => activate(item));
      });

      mobileQuery.addEventListener('change', updateHeaderColour);
    });
  };

  initHeroFunnels();
  document.addEventListener('shopify:section:load', (event) => initHeroFunnels(event.target));
})();
